
import { Component, OnInit, Inject, ElementRef, NgZone, ViewChild } from '@angular/core';
import { CustomerServiceIdentity } from '../services/customer.service';
import { JobsiteService } from '../services/jobsite.service';
import { CustomerOverview, JobSiteType, CountryVM } from '../models/customer.model';
import { NewJobsite } from '../models/jobsite.model';
import { FormControl } from '@angular/forms';
// import { } from 'googlemaps';
//import { MapsAPILoader } from '@agm/core';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomerSelectItem } from '../../setup-equipment/setup-equipment.model';

@Component({
    selector: 'add-jobsite-modal',
    templateUrl: './add-jobsite-modal.component.html',
    styleUrls: ['./add-jobsite-modal.component.scss']
})
export class AddJobsiteModalComponent implements OnInit {
    public searchControl: FormControl;
    @ViewChild("search")
    public searchElementRef: ElementRef;
  public customerList: CustomerSelectItem[];
    public jobsiteTypeList: JobSiteType[];
    public countryList: CountryVM[];
    public countryId: number = 0;
    public selectedCustomerId: number = 0;
    public selectedJobsiteTypeId: number = 0;
    public jobsiteName: string = '';
    public fullAddress: string = '';
    public city: string = '';
    public postCode: string = '';
    public state: string = '';
    public country: string = '';

    public savingNewJobsite: boolean = false;

    public longtitude:number;
    public latitude:number;
    showAll:boolean=true;
    isBasicUser:number=1;
    constructor(public dialogRef: MatDialogRef<AddJobsiteModalComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
        private _jobsiteService: JobsiteService, private _customerService: CustomerServiceIdentity,// private mapsAPILoader: MapsAPILoader,
        private ngZone: NgZone, public snackBar: MatSnackBar, private _notifications: NotificationsService) { }

    ngOnInit() {
        this.searchControl = new FormControl();
        //this._customerService.getAllCustomers().subscribe(result => {
        //    this.customerList = result;
        //});
        this._customerService.getCustomerList().subscribe(result => {
            this.customerList = result;
        });
        this._customerService.CheckUCUserType().subscribe(result => {
            this.isBasicUser = result;
            if(this.isBasicUser==1)this.showAll=true
            else this.showAll=false;
        });

        if (this.data != null) {
            this.selectedCustomerId = this.data.customerId;
        }

        this._customerService.getJobsiteTypes().subscribe(result => {
            this.jobsiteTypeList = result;
        });

        this._customerService.getAllCountries().subscribe(result => {
                       this.countryList = result;
                   });

        // this.mapsAPILoader.load().then(() => {
        //     let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, {
        //         types: ["address"]
        //     });
        //     google.maps.event.addListener(autocomplete, 'place_changed', () => {
        //         this.ngZone.run(() => {
        //             let place = autocomplete.getPlace();
        //             this.fullAddress = place.formatted_address;
        //             let addressComponents = place.address_components;
        //             addressComponents.forEach(c => {
        //                 if (c.types[0] == 'locality') {
        //                     this.city = c.long_name;
        //                 } else if (c.types[0] == 'postal_code') {
        //                     this.postCode = c.long_name;
        //                 } else if (c.types[0] == 'administrative_area_level_1') {
        //                     this.state = c.long_name;
        //                 } else if (c.types[0] == 'country') {
        //                     this.country = c.long_name;
        //                     this.LoadCountryByAddress(this.country)
        //                 }
        //             });
        //         });
        //     });
        // });
    }
    ShowAllFields(){
        this.showAll=true;
    }
    LoadCountryByAddress(value: string) {
        this.countryList.filter(x => {
            if (x.CountryName === value) {
                this.countryId = x.CountryCode;
                this.country=x.CountryName;
            }
        })
    }

    onNoClick(): void {
        this.dialogRef.close();
    }

    SelectCountry(event){
        let value = this.countryList.filter(x=>x.CountryCode== event.target.value)
       this.country = value[0].CountryName;
    }

    addNewJobsite() {
        if (this.savingNewJobsite)
            return;
        if (this.selectedCustomerId < 1 || this.jobsiteName.length < 1  || this.countryId < 1) {
            this.snackBar.open('Please fill in all required fields (*)', '', {
                duration: 1500,
            });
            return;
        }

        if (this.latitude < -90 || this.latitude>90) {
            this.snackBar.open('Latitude must be between -90 and 90 degrees inclusive.', '', {
                duration: 1500,
            });
            return;
        }
        if (this.longtitude < -180 || this.longtitude>180) {
            this.snackBar.open('Longitude must be between -180 and 180 degrees inclusive.', '', {
                duration: 1500,
            });
            return;
        }
        this.savingNewJobsite = true;

        let newJobsite: NewJobsite = {
            JobsiteName: this.jobsiteName,
            FullAddress: this.fullAddress,//this.fullAddress==""?this.city +','+ this.country : this.fullAddress,
            City: this.city,
            Country: this.country,
            CreatedByUserId: 0,
            CustomerId: this.selectedCustomerId,
            PostCode: this.postCode,
            State: this.state,
            JobsiteTypeId: this.selectedJobsiteTypeId,
            CountryId: this.countryId,
            Latitude: this.latitude,
            Longtitude: this.longtitude
        };
        this._jobsiteService.addNewJobsite(newJobsite).subscribe(result => {
            
            this.savingNewJobsite = false;
            if (!(result > 0)) {
                this._notifications.error('Failed', 'Could not create this job site. ');
            } else {
                this._notifications.success('Job Site Added', 'This job site has been added successfully. ');
                this.dialogRef.close(true);
            }
        });
    }
}
